import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { UndefinedGlossaryTerm } from '@portal-core/reports/models/undefined-glossary-terms.model';

@CollectionStateSelectors({
  stateType: ProjectReportsUndefinedGlossaryTermsState
})
@State<ProjectReportsUndefinedGlossaryTermsState>({
  name: ProjectReportsUndefinedGlossaryTermsState.source
})
@Service({ autoProvided: false })
export class ProjectReportsUndefinedGlossaryTermsState extends CollectionStateBase {
  static override source = 'ProjectReportsUndefinedGlossaryTerms';
  getSource(): string {
    return ProjectReportsUndefinedGlossaryTermsState.source;
  }
}

@Service()
export class ProjectReportsUndefinedGlossaryTermsDataService extends CollectionDataServiceBase<UndefinedGlossaryTerm> {
  protected readonly stateType = ProjectReportsUndefinedGlossaryTermsState;
}
